import { Section, SectionTitle } from '@/components/shared/Content';
import checkmark from '@/static/partners/checked.png';
import mobileLinkImg from '@/static/partners/partners-link-singular.png';
import tabledAndDesktopLinkImg from '@/static/partners/partners-link.png';
import { Box, Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import Image from 'next/image';
import type React from 'react';
import styled from 'styled-components';

const CheckContainer = styled(Box)`
  display: inline-block;

  ${MEDIA_QUERIES.tabletAndDesktop`
        display: none;
    `}
`;

const ImageContainer = styled(Box)`
  position: relative;
  width: 250px;
  height: 350px;
  background: url(${mobileLinkImg.src}) left 4px no-repeat;
  background-size: contain;

  ${MEDIA_QUERIES.tablet`
        width: 100%;
        height: 406px;
        background: url(${tabledAndDesktopLinkImg.src}) 50% 1px no-repeat;
        background-size: contain;
    `};

  ${MEDIA_QUERIES.desktop`
        width: 500px;
        height: 406px;
        background: url(${tabledAndDesktopLinkImg.src}) bottom no-repeat;
        background-size: contain;
        margin-right: 80px;
    `}
`;

const ReasonTitle = styled.h3`
  text-align: center;
  ${font('main', {
    fontSize: '2.6rem',
    lineHeight: '3.0rem',
    fontWeight: 700,
  })};
`;

const ReasonSubtitle = styled.p`
  max-width: 100%;
  text-align: center;
  ${font('main', { fontSize: '2.0rem', lineHeight: '3.0rem' })};

  ${MEDIA_QUERIES.desktop`
        text-align: left;
    `}
  text-wrap: balance;
`;

interface WhyUsProps {
  title: string;
  reasons: {
    key: string;
    title: string;
    subtitle: string;
  }[];
}

export const WhyUs: React.FC<WhyUsProps> = ({ title, reasons }) => {
  return (
    <Section darkBackground pt={80} pb={[0, 0, 40]}>
      <SectionTitle>{title}</SectionTitle>
      <Flex
        flexDirection={['column-reverse', 'column-reverse', 'row']}
        alignItems="center"
        justifyContent="center"
        width={[1, 0.8]}
        px={[35, 35, 0]}
        mt={[85, 50, 80]}
      >
        <ImageContainer />
        <Flex flexDirection="column" alignItems={['center', 'center', 'flex-start']} mb={[43, 0]} ml={[0, 0, 40]}>
          {reasons.map(({ key, title, subtitle }) => (
            <Flex
              key={key}
              flexDirection="column"
              alignItems={['center', 'center', 'flex-start']}
              mb={37}
              width={[1, 614, 460]}
            >
              <CheckContainer>
                <Image src={checkmark} width={25} height={25} alt="check mark" />
              </CheckContainer>
              <Box my={12}>
                <ReasonTitle>{title}</ReasonTitle>
              </Box>
              <ReasonSubtitle>{subtitle}</ReasonSubtitle>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Section>
  );
};
